import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hmt-optimization-animation-dialog',
  templateUrl: './optimization-animation-dialog.component.html',
  styleUrls: ['./optimization-animation-dialog.component.scss'],
  standalone: false
})
export class OptimizationAnimationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OptimizationAnimationDialogComponent>
  ) {}
}

